import Vue from "vue";
import VueRouter from "vue-router";
import blogEntries from "@/components/blogEntries";
import NewsFeed from "@/components/NewsFeed";
import LatestNews from "@/components/LatestNews";
import ContactUs from "@/components/ContactUs";
import CookiePolicy from "@/components/CookiePolicy";
import Disclamer from "@/components/Disclamer";
import TermsOfUse from "@/components/TermsOfUse";
import Article from "@/components/Article";
import About from "@/components/About";
import Help from "@/components/Help";
import NotFound from "@/components/404.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    name: "home",
    components: {
      latest: LatestNews,
      newsFeed: NewsFeed
    }
  },
  {
    path: "/blog",
    name: "blog",
    component: blogEntries
  },
  {
    path: "/contact",
    name: "contact",
    component: ContactUs
  },
  {
    path: "/legal-notes",
    name: "cookiePolicy",
    component: CookiePolicy
  },
  {
    path: "/terms-of-use",
    name: "termsOfUse",
    component: TermsOfUse
  },
  {
    path: "/disclamer",
    name: "disclamer",
    component: Disclamer
  },
  {
    path: "/latest/:id",
    name: "articles",
    props: true,
    component: Article
  },
  {
    path: "/trending/:id",
    name: "trending",
    props: true,
    component: Article
  },
  {
    path: "/emerging/:id",
    name: "emerging",
    props: true,
    component: Article
  },
  {
    path: "/about",
    name: "about",
    component: About
  },
  {
    path: "/help",
    name: "help",
    component: Help
  },
  {
    path: "*",
    name: "404",
    component: NotFound
  }
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

export default router;
